/**
 * @generated SignedSource<<a21cea41672023c29b967a31639a999e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VerifyEmailInput = {
  token: string;
};
export type ConfirmEmail_verifyEmail_Mutation$variables = {
  input: VerifyEmailInput;
};
export type ConfirmEmail_verifyEmail_Mutation$data = {
  readonly verifyEmail: {
    readonly token: string;
  } | null;
};
export type ConfirmEmail_verifyEmail_Mutation = {
  response: ConfirmEmail_verifyEmail_Mutation$data;
  variables: ConfirmEmail_verifyEmail_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyEmailPayload",
    "kind": "LinkedField",
    "name": "verifyEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfirmEmail_verifyEmail_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfirmEmail_verifyEmail_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94602192169f92c98481eec49e693fa3",
    "id": null,
    "metadata": {},
    "name": "ConfirmEmail_verifyEmail_Mutation",
    "operationKind": "mutation",
    "text": "mutation ConfirmEmail_verifyEmail_Mutation(\n  $input: VerifyEmailInput!\n) {\n  verifyEmail(input: $input) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "10dff23f10adf3919684c09513dea1db";

export default node;
